























































































































import colorsys from 'colorsys'
import Review from '@/components/Review'
import ToggleThreeState from '@/components/ToggleThreeState.vue'
# import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

# import { Bar } from 'vue-chartjs'

export default
    components: { Review, ToggleThreeState }
    props:
        id:
            default: 0
    data: ->
        person_type: 0 # Actor (doesn't correspond to type_id from the database)
    computed:
        colors: ->
            arr = {}
            for score in [0..100]
                color = colorsys.hsv_to_rgb
                    h: (score + 10) / 100 * 240 - 120
                    s: 50
                    v: 95
                arr[score] = "rgb(#{color.r}, #{color.g}, #{color.b})"
            return arr
        chartdata: ->
            data = @$store.state.data.graphs[@movie_id]
            c = document.getElementById("graph")
            if not c
                return data

            if not data
                return data

            c.width = c.parentNode.clientWidth
            w = c.width
            h = c.height

            data2 = data.slice() # make a copy, otherwise Vuex complains

            data2.sort((a, b) => a[2] - b[2])
            data2.push([null, @movie.imdb_score, @movie.imdb_votes])

            minx = 0
            maxx = @movie.imdb_votes
            miny = data2[0][1]
            maxy = data2[0][1]
            for row in data2
                miny = Math.min(miny, row[1])
                maxy = Math.max(maxy, row[1])
            miny = miny - 1
            maxy = maxy + 1

            ctx = c.getContext("2d")

            ctx.beginPath()
            ctx.strokeStyle  = "rgb(200,200,200)"
            for el in [miny..maxy]
                yy = h - (el - miny) * h / (maxy - miny)
                ctx.moveTo(0, yy)
                ctx.lineTo(maxx, yy)
                ctx.stroke()

            ctx.beginPath()
            ctx.strokeStyle = "black"
            for row in data2
                xx = (row[2] - minx) * w / (maxx - minx)
                yy = h - (row[1] - miny) * h / (maxy - miny)
                ctx.lineTo(xx, yy)
                ctx.stroke()
            return data2
        movie_id: ->
            return parseInt(@id)
        movie: ->
            # make sure cache is refreshed when the movie_changes state is changed
            trigger = @$store.state.data.movies_changes

            return @$store.state.data.movies.get(@movie_id)
        hidden:
            get: ->
                return if @movie.hidden then 1 else 0
            set: (value) ->
                if value != @movie.hidden
                    @$store.dispatch 'data/setMovieHiddenState',
                        id: @movie_id
                        hidden: value

        review: ->
            review = @$store.state.data.reviews[@movie_id]
            if review
                return review
            else
                return
                    movie_id: @movie_id
                    time: new Date().toISOString().substring(0, 19)
                    review_id: null
                    score: null
                    where: null
                    who: null
                    review: null
        seasons: ->
            num = @movie.episodes.length
            eps = []
            if num > 0
                for i in [0..num-1]
                    eps.push
                        index: i
                        id: @movie.episode_ids[i]
                        season: @movie.seasons[i]
                        episode: @movie.episodes[i]
                        air_date: @movie.air_dates[i]
                        review: @movie.episode_reviews[i]
                        imdb_score: @movie.ep_imdb_scores[i]
                        imdb_votes: @movie.ep_imdb_votes[i]
                
                eps.sort (a,b) ->
                    if a.season == b.season
                        return a.episode - b.episode
                    return a.season - b.season

            # Group into seasons, remembering original position of each episode in the unsorted list
            seasons = {}
            now = new Date()
            for ep in eps
                date = null
                if ep.air_date
                    date = new Date(ep.air_date)

                year = if date then date.getFullYear() else null

                # compute episode class for color
                if ep.review
                    ep.review = 'ro'
                else
                    if date <= now and date != null
                        ep.review = 'nrnor'
                    else
                        ep.review = 'nrnonr' # not reviewed not owned not released

                if ep.season of seasons
                    seasons[ep.season].years.push(year)
                    seasons[ep.season].eps.push(ep)
                    seasons[ep.season].tot_imdb_score += ep.imdb_score * ep.imdb_votes
                    seasons[ep.season].tot_imdb_votes += ep.imdb_votes
                else
                    seasons[ep.season] = {
                        years: [year]
                        eps: [ep]
                        tot_imdb_score: ep.imdb_score * ep.imdb_votes
                        tot_imdb_votes: ep.imdb_votes
                    }

            # compute average imdb score
            for season of seasons
                seasons[season].avg_imdb_score = Math.round(seasons[season].tot_imdb_score / seasons[season].tot_imdb_votes)

            # Gather unique years
            for season of seasons
                years = Array.from(new Set(seasons[season].years)).sort()
                
                # Remove year from eps dates if it makes sense
                if years.length <= 2
                    for ep in seasons[season].eps
                        if ep.air_date
                            ep.air_date = ep.air_date[5..]
                        else
                            ep.air_date = '?'

                seasons[season].years = years.join(" - ")

            return seasons

    created: ->
        @load_review()
    watch:
        'movie_id': (to, from) ->
            @load_review()
    methods:
        actors: (type_id) ->
            type_id = 1
            if @person_type == 0
                type_id = 1
            if @person_type == 1 # Director
                type_id = 3
            if @person_type == 2 # Writer
                type_id = 2

            arr = []
            for id in @movie.person_ids
                p = @$store.state.data.persons.get(id)
                if p.type != type_id
                    continue
                arr.push p
            arr = arr.sort (a, b) => a.rank_by_type - b.rank_by_type
            return arr

        load_review: ->
            console.log "Loading review"
            @$store.dispatch('data/loadReview', @movie_id)
            # console.log @$store.state.values.score_color
        save: ->
            console.log "SAVING"
            console.log @review
            @$store.dispatch('data/saveReview', @review)
        toggleEpisode: (index) ->
            data =
                "movie_id": @movie_id
                "index": index
            @$store.dispatch('data/toggleReviewEpisode', data)
        toggleSeason: (episodes) ->
            data =
                "movie_id": @movie_id
                "indices": (ep.index for ep in episodes.eps)
            @$store.dispatch('data/toggleReviewSeason', data)


